import { map, size, without } from "lodash";
import { Color } from "@glossy";
import { percent } from "@tootools/number";

const STEPS: { percent: number; label: string; color: Color }[] = [
  {
    percent: 0,
    label: "FORM::PASSWORD_STRENGTH::WEAK",
    color: Color.Valencia,
  },
  {
    percent: 25,
    label: "FORM::PASSWORD_STRENGTH::WEAK",
    color: Color.Casablanca,
  },
  {
    percent: 50,
    label: "FORM::PASSWORD_STRENGTH::GOOD",
    color: Color.SummerSky,
  },
  {
    percent: 75,
    label: "FORM::PASSWORD_STRENGTH::STRONG",
    color: Color.MountainMeadow,
  },
];

const getStrength = (password: string = ""): number => {
  let strength = 0;
  const flags = [
    /[a-z]+/, // Lower letters
    /[0-9]+/, // Numbers
    /[A-Z]+/, // Upper letters
    /[$-/:-?{-~!"^_`[\]]/g, // Symbols
  ];
  const passedMatches = size(
    without(
      map(flags, (flag) => flag.test(password)),
      false
    )
  );
  strength += passedMatches;
  // penality (short password)
  strength = password.length < 9 ? Math.min(strength, 1) : strength;
  // penality (poor variety of characters)
  strength = passedMatches === 1 ? Math.min(strength, 1) : strength;
  strength = passedMatches === 3 ? Math.min(strength, 4) : strength;
  return strength;
};

export const getStep = (
  password: string = ""
): { percent: number; color: Color; label: string } => {
  let strength = getStrength(password);
  strength = strength > 4 ? 4 : strength > 0 ? strength - 1 : 0;
  return {
    percent: percent(strength + 1, STEPS.length),
    color: STEPS[strength].color,
    label: STEPS[strength].label,
  };
};
